/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
//actions
import { resetForm } from 'state/actions/shared_form_actions';
import { setFormEditableState, discardChanges } from 'state/actions/shared_form_actions';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { savePaymentInformationWithValidation, getPaymentInformation, changePaymentType } from 'state/actions/accountState/account_data';
import ExistingPayments from 'pages/dashboard/account/paymentinfo/existingpayments/existingpayments';



/* ========== ~~~~~~~~~~ PAYMENT INFO : EXISTING PAYMENTS : PARENT ~~~~~~~~~~ ========== */

// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    selectedPaymentType: accountData.selectedPaymentType,
    savedPaymentTypes: accountData.savedPaymentTypes,
    paymentInfo: accountData.paymentInfo,
    payoutThreshold: accountData.payoutThreshold,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    changePaymentType: (paymentType, paymentUUID) => dispatch(changePaymentType(paymentType, paymentUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExistingPayments);

